import { useCallback, useEffect, useState } from "react";
import {
  getAssistMode,
  setAssistMode as persistAssistMode,
  subscribeAssistMode,
  type AssistMode,
} from "@/lib/personalAssistant/paAssistModeStorage";

export function usePaAssistMode(): {
  assistMode: AssistMode;
  setAssistMode: (next: AssistMode) => void;
} {
  const [assistMode, setAssistModeState] = useState<AssistMode>(getAssistMode);

  useEffect(() => {
    const unsubscribe = subscribeAssistMode(setAssistModeState);
    setAssistModeState(getAssistMode());
    return unsubscribe;
  }, []);

  const setAssistMode = useCallback((next: AssistMode) => {
    persistAssistMode(next);
  }, []);

  return { assistMode, setAssistMode };
}
